<div class="glossary-page-skeleton">
  <div class="-left-pane">
    <wp-skeleton class="-title" [loading]="true"></wp-skeleton>
    <wp-skeleton class="-subtitle" [loading]="true"></wp-skeleton>

    <div class="-alphabet-bar">
      <wp-skeleton class="-alphabet-line" [loading]="true"></wp-skeleton>
    </div>

    <wp-skeleton class="-section-label" [loading]="true"></wp-skeleton>

    @for (item of [1,2,3,4,5]; track item) {
    <div class="-definition-block">
      <wp-skeleton class="-definition-title" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-line" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-line -medium" [loading]="true"></wp-skeleton>
      <wp-skeleton class="-line -medium" [loading]="true"></wp-skeleton>
    </div>
    }
  </div>

  <div class="-right-pane">
    <wp-skeleton class="-right-title" [loading]="true"></wp-skeleton>
    @for (row of [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18]; track row) {
    <wp-skeleton class="-right-row" [loading]="true"></wp-skeleton>
    }
  </div>
</div>
